// 工作台
export const workRoutesDic = [{ title: "工作", code: "", route: "/working" }];

// 业务
export const businessRoutesDic = [
	// { title: ' 业务', code: 'C/A', route: '/business/OM' },
	{ title: "运营中心-首页", code: "A/A/A1", route: "/business/maintain/home" },
	{ title: "运营中心-电站", code: "A/B/A1", route: "/business/maintain/plant" },
	{ title: "运营中心-报警", code: "A/D/A1", route: "/business/maintain/alarm" },
	{ title: "运维-首页", code: "F/A/A1", route: "/business/OM/home" },
	{ title: "运维-工单", code: "F/B/A1", route: "/business/OM/order" },
	{ title: "设备-首页", code: "B/H/A1", route: "/business/device/home" },
	{ title: "设备-列表", code: "B/A/A1", route: "/business/device/device" },
	{ title: "设备-操作审计", code: "B/D/A1", route: "/business/device/operationalAudit" },
	{ title: "产品", code: "B/E/A1", route: "/business/product/List" },
	{ title: "设备-固件管理", code: "B/B/A2", route: "/business/product/firmware" },
	{ title: "设备-批量任务", code: "B/F/A1", route: "/business/product/batchTask" },
	{ title: "配置信息", code: "B/G/A1", route: "/business/product/infoMaintenance" },
];

//系统
export const maintainRoutesDic = [
	{ title: "运营中心-首页", code: "A/A/A1", route: "/business/maintain/home" },
	{ title: "运营中心-电站", code: "A/B/A1", route: "/business/maintain/plant" },
	{ title: "运营中心-报警", code: "A/D/A1", route: "/business/maintain/alarm" },
];

//运维
export const omRoutesDic = [
	// { title: ' 业务', code: 'C/A', route: '/business/OM' },
	{ title: "运维-首页", code: "F/A/A1", route: "/business/OM/home" },
	{ title: "运维-工单", code: "F/B/A1", route: "/business/OM/order" },
];

// 设备中心
export const deviceRoutesDic = [
	{ title: "设备-首页", code: "B/H/A1", route: "/business/device/home" },
	{ title: "设备-列表", code: "B/A/A1", route: "/business/device/device" },
	// { title: '设备-配置列表', code: 'B/B/A4', route: '/device/collectorFastConfig' },
	{ title: "设备-操作审计", code: "B/D/A1", route: "/business/device/operationalAudit" },
	// { title: 'noPermisson', code: 'B', route: '/device/noPermisson' }
	// { title: '设备-操作日志', code: 'B/A/A1', route: '/device/operationalAudit' }
];
// 产品
export const productRoutesDic = [
	{ title: "产品", code: "B/E/A1", route: "/business/product/List" },
	{ title: "设备-固件管理", code: "B/B/A2", route: "/business/product/firmware" },
	{ title: "设备-批量任务", code: "B/F/A1", route: "/business/product/batchTask" },
	{ title: "配置信息", code: "B/G/A1", route: "/business/product/infoMaintenance" },
];

// 应用中心
export const applicationRoutesDic = [
	{ title: "首页", code: "C/A/A100", route: "/application/index" },
	{ title: "大屏", code: "C/A/A1", route: "/application/screen" },
	{ title: "体检", code: "C/A/A2", route: "/application/inspect" },
	{ title: "报表", code: "D/D/A3", route: "/application/report" },
	{ title: "sim卡充值", route: "/application/sim" },
	{ title: "维保记录", route: "/application/maintenance" },
	{ title: "组网", route: "/application/network" },
	{ title: "保险", route: "/application/insurance" },
	{ title: "虚拟气象站", route: "/application/virtualWeatherStation" },
];

// 管理中心
export const manageRoutesDic = [
	{ title: "关于商家", code: "D/C/A1", route: "/manage/provider" },
	{ title: "管理中心-组成员", code: "D/A/A2", route: "/manage/memberAuth/groupMember" },
	{ title: "管理中心-角色", code: "D/A/A6", route: "/manage/memberAuth/roles" },
	{ title: "外部关系", code: "D/D/A2", route: "/manage/external/relation" },
	{ title: "外部角色", code: "D/D/A10", route: "/manage/external/roles" },
	{ title: "标签", code: "D/B/A1", route: "/manage/tag" },
	{ title: "消息管理-报警消息", code: "D/E/A1", route: "/manage/message/Home" },
	{ title: "工单管理-模板", route: "/manage/template" },
];

export const allRoutes = [...maintainRoutesDic, ...deviceRoutesDic, ...productRoutesDic, ...applicationRoutesDic, ...manageRoutesDic];



// WEBPACK FOOTER //
// ./src/util/routesDic.js